module.exports = __webpack_public_path__ + "img/kn.c04c8e41.svg";